import React from 'react';
import styles from './main-menu.module.scss';
import sanitizeId from '../../../utils/sanitizeId';
import { MainMenuViewProps } from '../types';

const MainMenuView = ({
  activeMenu,
  activeMenuRef,
  className = '',
  handleKeyDown,
  menuNames,
  onMenuClick,
}: MainMenuViewProps) => (
  <ul
    className={`${styles.menu} ${className}`}
    aria-label="Main navigation menu"
  >
    {menuNames.map((menu) => (
      <li
        className={styles['menu-item']}
        key={menu}
      >
        <button
          aria-controls={`${sanitizeId(menu)}-panel`}
          aria-describedby={activeMenu === menu ? `${sanitizeId(menu)}-instructions` : undefined}
          aria-expanded={activeMenu === menu}
          aria-label={menu}
          className={styles['menu-item-button']}
          id={`${sanitizeId(menu)}-menu`}
          onClick={() => onMenuClick(menu)}
          onKeyDown={(e) => handleKeyDown(e, menu)}
          ref={activeMenu === menu ? activeMenuRef : undefined}
          type="button"
        >
          {menu}
          {/* Hidden instructions for screen readers */}
          {activeMenu === menu && (
          <span
            id={`${sanitizeId(menu)}-instructions`}
            className="sr-only"
            aria-live="polite"
          >
            Press Tab or Arrow Down to navigate to sub-menu items, Escape to close menu
          </span>
          )}
        </button>
      </li>
    ))}
  </ul>
);

export default MainMenuView;
